import { createCrudApi } from '@core/api/createCrudApi';
import type { BaseEntity } from '@core/interfaces';
import axiosInstance from '@core/utils/axiosInstance';
import type { MaterialKind } from '../src/enum/materialKind';
import type { MaterialColor } from './materialColor';

export interface MaterialType extends BaseEntity {
  kind: MaterialKind;
  name: string;
  sortOrder?: number;
  colors: MaterialColor[];
}

export interface MaterialTypeData {
  kind: MaterialKind;
  name: string;
}

const materialTypeApi = createCrudApi<
  MaterialType,
  MaterialTypeData,
  MaterialTypeData
>('material-type');

export async function getMaterialTypes(
  kind: MaterialKind
): Promise<MaterialType[]> {
  const { data } = await axiosInstance.get<MaterialType[]>('/material-type', {
    params: { kind },
  });
  return data;
}

export const getAllMaterialTypes = materialTypeApi.getAll;
export const reorderMaterialTypes = (kind: MaterialKind, ids: number[]) =>
  materialTypeApi.reorder(ids, { kind });
export const createMaterialType = materialTypeApi.create;
export const updateMaterialType = materialTypeApi.update;
export const deleteMaterialType = materialTypeApi.delete;
